// Copyright 2020 TOKU Systems Inc.

import React, { useState, ChangeEventHandler } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  MenuItem,
  DialogActions,
  Button,
} from '@material-ui/core';
import moment from 'moment-timezone';

interface AddApiKeyDialogProps {
  open: boolean;
  onAddApiKey: (description: string, expiresIn: number) => void;
  onCancel: () => void;
}

export default function AddApiKeyDialog(
  props: AddApiKeyDialogProps
): JSX.Element {
  const [description, setDescription] = useState('');
  const [descriptionError, setDescriptionError] = useState(false);
  const [descriptionHelperText, setDescriptionHelperText] = useState('');
  const [ttl, setTtl] = useState(moment.duration('P1M').asMilliseconds());

  const handleDescriptionChange: ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event) => setDescription(event.target.value);
  const handleExpiryChange: ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event) => setTtl(parseInt(event.target.value));
  const handleAddClick = (): void => {
    let valid = true;
    if (description.trim() === '') {
      valid = false;
      setDescriptionError(true);
      setDescriptionHelperText('A description is required.');
    } else {
      setDescriptionError(false);
    }

    if (valid) {
      props.onAddApiKey(description, ttl);
    }
  };

  return (
    <Dialog open={props.open} onClose={props.onCancel}>
      <DialogTitle>Add API key</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please enter a brief description for the API key to add.
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          label="Description"
          type="text"
          required
          error={descriptionError}
          helperText={descriptionHelperText}
          value={description}
          onChange={handleDescriptionChange}
          fullWidth
        />
        <TextField
          select
          margin="dense"
          label="Expiry"
          value={ttl}
          onChange={handleExpiryChange}
          type="text"
          fullWidth
        >
          <MenuItem value={moment.duration('P1M').asMilliseconds()}>
            Expires in 1 month
          </MenuItem>
          <MenuItem value={moment.duration('P1Y').asMilliseconds()}>
            Expires in 1 year
          </MenuItem>
          <MenuItem value={moment.duration('P5Y').asMilliseconds()}>
            Expires in 5 years
          </MenuItem>
          <MenuItem value={moment.duration('P10Y').asMilliseconds()}>
            Expires in 10 years
          </MenuItem>
          <MenuItem value={-1}>Never expires</MenuItem>
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onCancel}>Cancel</Button>
        <Button onClick={handleAddClick}>Add</Button>
      </DialogActions>
    </Dialog>
  );
}
